import { Button, Group, Text } from '@mantine/core';
import { AlertCircle, ArrowLeft, ArrowRight } from 'react-feather';

interface StepNavProps {
  showBack: boolean;
  nextLabel: string;
  nextDisabled: boolean;
  /** Why Next is disabled, shown beside it. */
  hint?: string;
  onBack: () => void;
  onNext: () => void;
}

export function StepNav({
  showBack,
  nextLabel,
  nextDisabled,
  hint,
  onBack,
  onNext,
}: StepNavProps) {
  return (
    <Group justify="space-between" mt="lg">
      <div>
        {showBack && (
          <Button
            variant="default"
            leftSection={<ArrowLeft size={16} />}
            onClick={onBack}
          >
            Back
          </Button>
        )}
      </div>
      <Group gap="md">
        {hint && (
          <Group gap={6} c="dangerRed.7">
            <AlertCircle size={18} />
            <Text fw={700} size="sm">
              {hint}
            </Text>
          </Group>
        )}
        <Button
          size="md"
          rightSection={<ArrowRight size={16} />}
          disabled={nextDisabled}
          onClick={onNext}
        >
          {nextLabel}
        </Button>
      </Group>
    </Group>
  );
}
